$('.info-boxen .carousel .carousel-item').each(function(){
    var next = $(this).next();
    if (!next.length) {
        next = $(this).siblings(':first');
    }
    next.children(':first-child').clone().appendTo($(this));

    if (next.next().length>0) {
        next.next().children(':first-child').clone().appendTo($(this));
    }
    else {
        $(this).siblings(':first').children(':first-child').clone().appendTo($(this));
    }
});
$(document).ready(function() {
    $("#infoBoxenCarousel").swiperight(function() {
        $("#infoBoxenCarousel").carousel('prev');
    });
    $("#infoBoxenCarousel").swipeleft(function() {
        $("#infoBoxenCarousel").carousel('next');
    });
});